import { render, staticRenderFns } from "./UIMultiSelect.vue?vue&type=template&id=02b6ae9d&"
import script from "./UIMultiSelect.vue?vue&type=script&lang=js&"
export * from "./UIMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports